import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.some.js";
import axios from '@/api/axios';
import { legalPayload } from '@/utils/legal-documents';
export default {
  name: 'PortalLegalRenewal',
  props: {
    authenticated: {
      type: Boolean,
      default: false
    },
    patientId: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['blocking'],
  data: () => ({
    status: null,
    statusSessionKey: null,
    choices: {
      terms: false,
      gdpr: false
    },
    loading: false,
    saving: false,
    error: '',
    requestId: 0,
    retryTimer: null
  }),
  computed: {
    sessionKey() {
      return this.authenticated ? `patient:${this.patientId || 'loading'}` : 'guest';
    },
    blocking() {
      return this.authenticated && this.status?.login_acceptance_required === true;
    },
    canSave() {
      return this.status?.login_acceptance_required === true && this.choices.terms === true && this.choices.gdpr === true;
    },
    terms() {
      return this.status?.documents.find(document => document.key === 'terms');
    },
    privacy() {
      return this.status?.documents.find(document => document.key === 'gdpr');
    }
  },
  watch: {
    sessionKey: {
      immediate: true,
      handler() {
        this.refresh();
      }
    },
    blocking: {
      immediate: true,
      handler(value) {
        this.$emit('blocking', value);
        this.$nextTick(this.syncDialog);
      }
    }
  },
  mounted() {
    this.syncDialog();
  },
  beforeUnmount() {
    this.requestId++;
    clearTimeout(this.retryTimer);
    this.$refs.dialog?.close();
    document.documentElement.classList.remove('portal-legal-renewal-open');
  },
  methods: {
    syncDialog() {
      const dialog = this.$refs.dialog;
      if (!dialog) return;
      document.documentElement.classList.toggle('portal-legal-renewal-open', this.blocking);
      // Native modal dialogs trap focus and make the rest of the page inert.
      if (this.blocking && !dialog.open) dialog.showModal();
      if (!this.blocking && dialog.open) dialog.close();
    },
    validateStatus(status) {
      if (typeof status?.login_acceptance_required !== 'boolean' || !Array.isArray(status.documents) || !['terms', 'gdpr'].every(key => status.documents.some(document => document.key === key && document.version && document.url))) {
        throw new Error('Invalid legal-document status');
      }
    },
    publishStatus(status) {
      const patient = this.$store?.getters['user/authenticated'];
      if (patient?.id && String(patient.id) === String(this.patientId)) {
        Promise.resolve(this.$store.dispatch('user/setAuthenticated', {
          ...patient,
          legal: status
        })).catch(() => {});
      }
    },
    async refresh() {
      const request = ++this.requestId;
      clearTimeout(this.retryTimer);
      this.retryTimer = null;
      // Check silently, but never unlock an already confirmed obligation
      // while retrying the same patient's status.
      if (this.statusSessionKey !== this.sessionKey) this.status = null;
      this.statusSessionKey = this.sessionKey;
      this.error = '';
      this.choices = {
        terms: false,
        gdpr: false
      };
      this.saving = false;
      this.loading = this.authenticated;
      if (!this.authenticated) return;
      try {
        const {
          data
        } = await axios.get('portal/legal-documents');
        if (request !== this.requestId || !this.authenticated) return;
        this.validateStatus(data);
        this.status = data;
        this.publishStatus(data);
      } catch (_) {
        if (request === this.requestId && this.authenticated) {
          this.error = 'A dokumentumok ellenőrzése nem sikerült. Kérjük, próbálja újra.';
          this.retryTimer = setTimeout(() => this.refresh(), 15000);
        }
      } finally {
        if (request === this.requestId) this.loading = false;
      }
    },
    async save() {
      if (!this.canSave || this.saving || this.loading) return;
      clearTimeout(this.retryTimer);
      this.retryTimer = null;
      const request = this.requestId;
      this.saving = true;
      this.error = '';
      try {
        const {
          data
        } = await axios.post('portal/legal-documents/login-acceptance', legalPayload(this.choices, this.status.documents));
        if (request !== this.requestId || !this.authenticated) return;
        this.validateStatus(data);
        if (data.login_acceptance_required || !data.complete) throw new Error('Acceptance incomplete');
        this.status = data;
        this.publishStatus(data);
      } catch (_) {
        if (request === this.requestId && this.authenticated) this.error = 'Az elfogadások mentése nem sikerült. Kérjük, próbálja újra a Mentés gombbal, vagy töltse újra a dokumentumokat.';
      } finally {
        if (request === this.requestId) this.saving = false;
      }
    }
  }
};